export default "__VITE_ASSET__ebf513a5__"